const task = {
	name: 'Wiedervorlage | Wiedervorlagen',
	icon: 'fa-fw fa-solid fa-clipboard-list-check',
	fields: {
		task_type: {
			name: 'Typ',
		},
		text: 'Beschreibung',
		due_date: 'Fällig am',
		team_id_assigned: 'Zugewiesen an',
	},
}

export default task
